package app.nestbridge.feature.home.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object HomeScreen : Screen

data class HomeState(
    val eventSink: (HomeEvent) -> Unit,
) : CircuitUiState

sealed interface HomeEvent
